// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgLineAlt: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <path
        fill={secondary ?? 'transparent'}
        d="M24 10.3C24 4.932 18.617.564 12 .564S0 4.93 0 10.3c0 4.814 4.27 8.845 10.036 9.607.39.085.922.258 1.057.592.122.304.08.778.04 1.085 0 0-.14.847-.171 1.027-.053.304-.24 1.187 1.04.647s6.91-4.07 9.427-6.967C23.168 14.385 24 12.45 24 10.301"
      />
      <path
        fill={primary ?? fill ?? 'currentColor'}
        fillRule="evenodd"
        d="M12 .563c6.617 0 12 4.368 12 9.738 0 2.149-.832 4.084-2.571 5.991C18.912 19.19 13.282 22.72 12 23.26c-1.247.526-1.1-.298-1.043-.622l.004-.025.17-1.027c.04-.307.083-.781-.039-1.085-.135-.334-.666-.507-1.057-.592C4.27 19.146 0 15.115 0 10.301 0 4.93 5.383.563 12 .563m-4.234 12.61a.23.23 0 0 1-.23.229h-3.37a.229.229 0 0 1-.23-.23V7.934a.23.23 0 0 1 .23-.23h.851a.23.23 0 0 1 .23.23v4.157h2.29a.23.23 0 0 1 .23.23zm8.87.229h3.37v.003c.128 0 .23-.102.23-.23v-.85a.23.23 0 0 0-.23-.23h-2.29v-.884h2.29a.23.23 0 0 0 .23-.23v-.851a.23.23 0 0 0-.23-.23h-2.29v-.884h2.29c.128 0 .23-.102.23-.23v-.85a.23.23 0 0 0-.23-.23h-3.37a.229.229 0 0 0-.23.23v5.236c0 .127.103.23.23.23m-7.07-5.696h-.85a.23.23 0 0 0-.23.23v5.236c0 .127.103.23.23.23h.85a.23.23 0 0 0 .23-.23V7.935a.23.23 0 0 0-.23-.229m4.942 0h.852v.002a.23.23 0 0 1 .23.23v5.237a.23.23 0 0 1-.23.229h-.845a.213.213 0 0 1-.06-.009h-.003a.095.095 0 0 1-.016-.004l-.003-.002h-.004l-.01-.005-.007-.003a.17.17 0 0 1-.005-.003l-.007-.003-.014-.01-.003-.001a.225.225 0 0 1-.06-.058l-2.399-3.24v3.11a.23.23 0 0 1-.229.23h-.851a.23.23 0 0 1-.23-.23V7.939a.23.23 0 0 1 .23-.23h.866a.06.06 0 0 1 .006.001h.006a.031.031 0 0 0 .01.002c.005 0 .01.003.014.003a.18.18 0 0 1 .021.007l.008.002a.038.038 0 0 1 .013.006l.007.003.012.007.004.002.003.002.013.008.002.002h.001l.003.003.013.01.004.003.004.003a.068.068 0 0 1 .01.013.235.235 0 0 0 .01.012l.009.011 2.396 3.236v-3.11c0-.127.102-.229.23-.229"
        clipRule="evenodd"
      />
    </svg>
  );
};

const Memo = memo(SvgLineAlt);
export default Memo;
